import React, { ReactElement, Fragment, Suspense, useEffect } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import Loader from '@lwt-helix/loader';

import { AppStoreApi, useAppStore } from './stores/appStore';
import Constants from './common/constants';

const Login = React.lazy(() => import('./components/login/Login'));
const ForgotPassword = React.lazy(() =>
    import('./components/forgot-password/ForgotPassword')
);
const ForgotPasswordConfirmation = React.lazy(() =>
    import('./components/forgot-password/ForgotPasswordConfirmation')
);
const LinkAccount = React.lazy(() =>
    import('./components/link-account/LinkAccount')
);

const Redirect = (props: RouteComponentProps): ReactElement => {
    const { redirectUri } = props.location.state;

    useEffect((): void => {
        window.location.replace(redirectUri);
    }, [redirectUri]);

    return <Loader />;
};

const fallBack = (): ReactElement => {
    return <Fragment />;
};

const Routes = (): React.ReactElement => {
    const {
        auth0: { queryStringParams }
    }: AppStoreApi = useAppStore();

    return (
        <Switch>
            <Route
                path={Constants.Routes.LOGIN}
                render={(props: RouteComponentProps): ReactElement => (
                    <Suspense fallback={fallBack()}>
                        <Login {...props} />
                    </Suspense>
                )}
            />
            <Route
                path={Constants.Routes.FORGOT_PASSWORD}
                render={(props: RouteComponentProps): ReactElement => (
                    <Suspense fallback={fallBack()}>
                        <ForgotPassword {...props} />
                    </Suspense>
                )}
            />
            <Route
                path={Constants.Routes.FORGOT_PASSWORD_CONFIRMATION}
                render={(props: RouteComponentProps): ReactElement => (
                    <Suspense fallback={fallBack()}>
                        <ForgotPasswordConfirmation {...props} />
                    </Suspense>
                )}
            />
            <Route
                path={Constants.Routes.LINK_ACCOUNT}
                render={(props: RouteComponentProps): ReactElement => (
                    <Suspense fallback={fallBack()}>
                        <LinkAccount {...props} />
                    </Suspense>
                )}
            />
            <Route
                path={Constants.Routes.REDIRECT_URI}
                component={Redirect}
                loc={queryStringParams.redirectUri}
            />
        </Switch>
    );
};

export default Routes;
